import React from 'react';

const Recording = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Recording
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          This Agreement will not be recorded in the Office of the Recorder of
          Deeds or in any other office or place of public record. If Buyer
          causes or permits this Agreement to be recorded, Seller may elect to
          treat such act as a default of this Agreement.
        </li>
      </ol>
    </div>
  );
};

export default Recording;
